(function() {
  window.App = Ember.Application.create();

  App.Router.reopen({
    location: "history"
  });

  App.Router.map(function() {
    this.route("collections", {
      path: "/collections"
    });
    return this.route("pages", {
      path: "/pages"
    });
  });

}).call(this);
